import { useState, useEffect } from "react";
import { useAppSelector } from "../redux";
import { useEffectiveOrganization } from "./useEffectiveOrganization";

export type OrganizationTier = "enterprise" | "developer";

export const useAuth = () => {
  const [user, setUser] = useState<any>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [organizationTier, setOrganizationTier] = useState<OrganizationTier | null>(null);

  const sessionUser = useAppSelector((state) => state.session.user);
  const { organization } = useEffectiveOrganization();

  useEffect(() => {
    if (sessionUser) {
      setUser(sessionUser);
      setIsAdmin(sessionUser.isAdmin);
    } else {
      setUser(null);
      setIsAdmin(false);
    }
  }, [sessionUser]);

  useEffect(() => {
    setOrganizationTier((organization?.tier as OrganizationTier) || null);
  }, [organization?.tier]);

  return { user, isAdmin, organizationTier };
};
